export default __webpack_public_path__ + "8e726d4.png";